import * as React from 'react'
import {
  Container,
  Header,
  Segment,
  Label,
  Image,
  Grid,
  Modal,
} from 'semantic-ui-react'
import History from './History'
import MVV from './MVV'
import Services from './Services'

type OfficeItemProps = {
  label: string,
  image: string,
} | any

type OfficeItemWithModalProps = {
  title: string,
} | OfficeItemProps

const OfficeItem = ({ label, image, ...props }: OfficeItemProps) => (
  <Segment padded {...props} className='pointer'>
    <Label attached='bottom' size='large'>{label}</Label>
    <Image src={'//res.cloudinary.com/danrx4fes/image/upload/c_fill,w_350,ar_16:9/' + image} />
  </Segment>
)

const OfficeItemWithModal = ({ children, title, label, image }: OfficeItemWithModalProps) => (
  <Modal trigger={<OfficeItem label={label} image={image} />} dimmer='blurring' closeIcon>
    {title && <Modal.Header>{title}</Modal.Header>}
    <Modal.Content>
      <Modal.Description>{children}</Modal.Description>
    </Modal.Content>
  </Modal>
)

const Office = () => {
  return (
    <Container id='office'>
      <Header size='huge' textAlign='center'>
        O Escritório
      </Header>
      <Grid
        columns='3'
        textAlign='center'
        relaxed
        stackable
        className='container'
      >
        <Grid.Row>
          <Grid.Column>
            <OfficeItemWithModal label='G&A' image='CAPA/01-FOTO_SITE-CAIXA_G_A.jpg'>
              <History />
            </OfficeItemWithModal>
          </Grid.Column>
          <Grid.Column>
            <OfficeItemWithModal label='Missão Visão e Valores' image='CAPA/02-LOGO_GEA-CAIXA_MVV.jpg'>
            <MVV />
            </OfficeItemWithModal>
          </Grid.Column>
          <Grid.Column>
            <OfficeItemWithModal label='O que fazemos' image='CAPA/03-SERVI%C3%87OS_CAIXA.png'>
              <Services />
            </OfficeItemWithModal>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  )
}

export default Office
